function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 19H17.4",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.903 6.50014L16.5708 5.83414C16.8338 5.57123 17.0424 5.2591 17.1848 4.91556C17.3271 4.57203 17.4004 4.20382 17.4004 3.83196C17.4005 3.46011 17.3273 3.09188 17.185 2.74832C17.0427 2.40475 16.8342 2.09257 16.5713 1.82959C16.3084 1.56662 15.9962 1.35801 15.6527 1.21567C15.3092 1.07333 14.941 1.00004 14.5691 1C14.1972 0.999958 13.829 1.07316 13.4854 1.21542C13.1419 1.35769 12.8297 1.56623 12.5667 1.82914L11.8989 2.49694C11.8989 2.49694 11.9826 3.91534 13.2336 5.16634C14.4846 6.41734 15.903 6.50105 15.903 6.50105L9.76773 12.6363C9.35193 13.0521 9.14493 13.2591 8.91543 13.4382C8.64483 13.6494 8.35413 13.8291 8.04333 13.9773C7.78143 14.1024 7.50242 14.1951 6.94532 14.3805L4.58192 15.1689M11.8989 2.49604L5.76363 8.63224C5.34783 9.04804 5.13993 9.25504 4.96173 9.48454C4.75063 9.75462 4.56984 10.0471 4.42262 10.3566C4.29752 10.6185 4.20483 10.8975 4.01853 11.4546L3.23103 13.818M3.23103 13.818L3.03933 14.3949C2.99439 14.5295 2.98782 14.6738 3.02036 14.8119C3.0529 14.9499 3.12325 15.0762 3.22354 15.1764C3.32382 15.2767 3.45006 15.3471 3.5881 15.3796C3.72614 15.4121 3.87051 15.4056 4.00503 15.3606L4.58192 15.1689M3.23103 13.818L4.58192 15.1689",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCard);
export default __webpack_public_path__ + "static/media/editCard.a9df7159a1a263b7f0fe8fbda9a76c8c.svg";
export { ForwardRef as ReactComponent };